import React from 'react';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  return (
    <div className="AboutPage">
      {/* Hero Section for About */}
      <section className="section" style={{ 
        background: 'linear-gradient(135deg, var(--primary-100), var(--background-surface))',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 style={{ color: 'var(--primary-700)' }}>About Snow's Garden Center</h1>
          <p style={{ fontSize: 'var(--text-lg)', maxWidth: '800px', margin: '0 auto' }}>
            Discover the rich heritage and commitment to excellence that has made Snow's Garden Center 
            Central Virginia's premier landscaping and garden center for over 110 years.
          </p>
        </div>
      </section>

      {/* History Section */}
      <section className="section">
        <div className="container">
          <div className="grid grid-cols-2" style={{ alignItems: 'center', gap: 'var(--space-xxxl)' }}>
            <div>
              <h2>A Fourth-Generation Family Tradition</h2>
              <p style={{ fontSize: 'var(--text-lg)', marginBottom: 'var(--space-md)' }}>
                Established in spring 1912 by Leroy H. Snow and his wife Maggie, Snow's Garden Center 
                has been Central Virginia's trusted partner in creating beautiful outdoor spaces for over 110 years.
              </p>
              <p style={{ marginBottom: 'var(--space-md)' }}>
                Today, as a fourth-generation family-owned business, we continue to honor the tradition 
                of excellence established by our founders. Our team of professionals combines decades of 
                experience with modern techniques to help you maximize your enjoyment of outdoor living spaces.
              </p>
              <p style={{ marginBottom: 'var(--space-lg)' }}>
                We proudly serve Charlottesville and surrounding areas including Albemarle, Fluvanna, 
                and Augusta Counties, as well as Lake Anna. From concept to completion, we're committed 
                to bringing your vision to life.
              </p>
              <div style={{ display: 'flex', gap: 'var(--space-md)', flexWrap: 'wrap' }}>
                <Link to="/portfolio" className="btn btn-primary">
                  View Our Work
                </Link>
                <Link to="/contact" className="btn btn-secondary">
                  Meet Our Team
                </Link>
              </div>
            </div>
            
            <div className="card" style={{ 
              background: 'linear-gradient(135deg, var(--primary-100), var(--background-surface))',
              textAlign: 'center'
            }}>
              <h3 style={{ color: 'var(--primary-700)', marginBottom: 'var(--space-md)' }}>
                Our Service Areas
              </h3>
              <ul style={{ 
                listStyle: 'none', 
                padding: 0,
                textAlign: 'left'
              }}>
                <li style={{ 
                  padding: 'var(--space-sm) 0', 
                  borderBottom: '1px solid var(--neutral-400)',
                  color: 'var(--neutral-900)'
                }}>
                  <strong>Charlottesville</strong> - Our home base and primary service area
                </li>
                <li style={{ 
                  padding: 'var(--space-sm) 0', 
                  borderBottom: '1px solid var(--neutral-400)',
                  color: 'var(--neutral-900)'
                }}>
                  <strong>Albemarle County</strong> - Comprehensive landscaping services
                </li>
                <li style={{ 
                  padding: 'var(--space-sm) 0', 
                  borderBottom: '1px solid var(--neutral-400)',
                  color: 'var(--neutral-900)'
                }}>
                  <strong>Fluvanna County</strong> - Garden center and installation services
                </li>
                <li style={{ 
                  padding: 'var(--space-sm) 0', 
                  borderBottom: '1px solid var(--neutral-400)',
                  color: 'var(--neutral-900)'
                }}>
                  <strong>Augusta County</strong> - Professional landscape solutions
                </li>
                <li style={{ 
                  padding: 'var(--space-sm) 0',
                  color: 'var(--neutral-900)'
                }}>
                  <strong>Lake Anna</strong> - Custom outdoor living spaces
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Company Values */}
      <section className="section" style={{ backgroundColor: 'var(--background-surface)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 'var(--space-xxxl)' }}>
            <h2>Our Values & Commitment</h2>
            <p style={{ fontSize: 'var(--text-lg)', color: 'var(--neutral-400)', maxWidth: '600px', margin: '0 auto' }}>
              Built on generations of trust, innovation, and excellence in serving Central Virginia's outdoor needs.
            </p>
          </div>
          
          <div className="grid grid-cols-3">
            <div className="card service-card">
              <div className="service-icon">
                <svg fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z"/>
                </svg>
              </div>
              <h3 className="service-title">Quality Craftsmanship</h3>
              <p className="service-description">
                Every project is executed with meticulous attention to detail and the highest standards of quality.
              </p>
            </div>
            
            <div className="card service-card">
              <div className="service-icon">
                <svg fill="currentColor" viewBox="0 0 24 24">
                  <path d="M16,13C15.71,13 15.38,13 15.03,13.05C16.19,13.89 17,15 17,16.5V19H23V16.5C23,14.17 18.33,13 16,13M8,13C5.67,13 1,14.17 1,16.5V19H15V16.5C15,14.17 10.33,13 8,13M8,11A3,3 0 0,0 11,8A3,3 0 0,0 8,5A3,3 0 0,0 5,8A3,3 0 0,0 8,11M16,11A3,3 0 0,0 19,8A3,3 0 0,0 16,5A3,3 0 0,0 13,8A3,3 0 0,0 16,11Z"/>
                </svg>
              </div>
              <h3 className="service-title">Family Heritage</h3>
              <p className="service-description">
                Four generations of family ownership ensures personal care and commitment to every client relationship.
              </p>
            </div>
            
            <div className="card service-card">
              <div className="service-icon">
                <svg fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M15.5,8C16.3,8 17,8.7 17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8M10,9A4,4 0 0,1 14,5A4,4 0 0,1 18,9A4,4 0 0,1 14,13A4,4 0 0,1 10,9M8.5,11A1.5,1.5 0 0,0 10,9.5A1.5,1.5 0 0,0 8.5,8A1.5,1.5 0 0,0 7,9.5A1.5,1.5 0 0,0 8.5,11M15.5,14A1.5,1.5 0 0,0 17,12.5A1.5,1.5 0 0,0 15.5,11A1.5,1.5 0 0,0 14,12.5A1.5,1.5 0 0,0 15.5,14"/>
                </svg>
              </div>
              <h3 className="service-title">Local Expertise</h3>
              <p className="service-description">
                Deep understanding of Central Virginia's climate, soil, and native plants ensures lasting results.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Customer Testimonial */}
      <section className="section">
        <div className="container">
          <div className="card" style={{ 
            textAlign: 'center',
            background: 'var(--primary-100)',
            border: '2px solid var(--primary-500)'
          }}>
            <blockquote style={{ 
              fontSize: 'var(--text-lg)', 
              fontStyle: 'italic',
              color: 'var(--neutral-900)',
              marginBottom: 'var(--space-md)'
            }}>
              "I have worked with Snow's for more than 25 years on landscape projects. They are always 
              timely, offer great service and complete jobs as promised. I know I can count on any 
              follow-up needed, and it's easy to communicate with them by email or website."
            </blockquote>
            <cite style={{ 
              fontWeight: '600', 
              color: 'var(--primary-700)',
              fontSize: 'var(--text-sm)'
            }}>
              — Paul, Charlottesville
            </cite>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="section" style={{ backgroundColor: 'var(--background-surface)' }}>
        <div className="container">
          <div style={{ textAlign: 'center' }}>
            <h2>Ready to Work with Central Virginia's Heritage Landscaping Experts?</h2>
            <p style={{ fontSize: 'var(--text-lg)', color: 'var(--neutral-400)', marginBottom: 'var(--space-xl)', maxWidth: '600px', margin: '0 auto var(--space-xl)' }}>
              Let our fourth-generation expertise help you create the outdoor space of your dreams.
            </p>
            <Link to="/contact" className="btn btn-primary">
              Start Your Project Today
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;